import { render, staticRenderFns } from "./TripCalendarView.vue?vue&type=template&id=58cb57ec&scoped=true"
import script from "./TripCalendarView.vue?vue&type=script&lang=js"
export * from "./TripCalendarView.vue?vue&type=script&lang=js"
import style0 from "./TripCalendarView.vue?vue&type=style&index=0&id=58cb57ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb57ec",
  null
  
)

export default component.exports